import * as api from '../api/authApi';
import * as types from '../constants/authConstants';
import { hydrateAndDispatch } from './authHelpers';

export const refreshUserDataAction = (data) => async (dispatch) => {
  const { access_token } = data;
  try {
    await hydrateAndDispatch(dispatch, access_token);
  } catch (error) {
    localStorage.removeItem('profile');
    dispatch({ type: types.LOGOUT, payload: error?.response?.data });
  }
};

export const refreshTokenAction = () => async (dispatch) => {
  try {
    const data = await api.refresh();
    await hydrateAndDispatch(dispatch, data.access_token);
  } catch (error) {
    localStorage.removeItem('profile');
    dispatch({ type: types.LOGOUT, payload: error?.response?.data });
  }
};
